import UseContext from 'hooks/useContext';
import { useEffect } from 'react';
import ApiDatabase, { dispatchSessionExpired } from 'server';

const Usefetchdata = () => {
  const {
    refreshUser,
    refreshWorker,
    userData,
    setUserData,
    tempWorkerData,
    setTempWorkerData,
  } = UseContext();

  useEffect(() => {
    if (!userData?._id) {
      ApiDatabase.getUserProfile(
        {},
        (data) => {
          setUserData(data);
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            const s = err.response?.status;
            if (s === 400 || s === 204 || s === 401) {
              dispatchSessionExpired();
            }
          }
        }
      );
    }
  }, [refreshUser, userData]);

  useEffect(() => {
    if (!tempWorkerData?._id) {
      ApiDatabase.getTempWorker(
        {},
        (data) => {
          setTempWorkerData(data);
        },
        (err) => {
          if (err.name !== 'CanceledError') {
            const s = err.response?.status;
            if (s === 400 || s === 204 || s === 401) {
              dispatchSessionExpired();
            } else {
              console.log(err);
            }
          }
        }
      );
    }
  }, [refreshWorker, tempWorkerData]);

  return {
    userData,
    tempWorkerData,
  };
};

export default Usefetchdata;
